/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'
import ReactPlayer from 'react-player'

const Video = ({
    title, videoLink,
}) => (
    <div className="video-wrapper" id="video">
        <div className="video-titles">
            <h2>{title}</h2>
        </div>

        <div className="video-gallery">
            <ReactPlayer
                url={videoLink}
                allowFullScreen
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                className="react-player"
                width="100%"
                height="100%"
                loop
                controls
            />
        </div>
    </div>
)

Video.propTypes = {
    title: PropTypes.string.isRequired,
    videoLink: PropTypes.string.isRequired,
}

export default Video
